import { render, staticRenderFns } from "./groupBox.vue?vue&type=template&id=c879358c&"
import script from "./groupBox.vue?vue&type=script&lang=js&"
export * from "./groupBox.vue?vue&type=script&lang=js&"
import style0 from "./groupBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports